"use client";
import {
  __name
} from "../../../chunk-SHUYVCID.js";

// src/sections/core/contact/contact-split.tsx
import { Icon } from "@core/icons";
import { Button } from "@core/ui/components/atoms/button";
import { Container } from "@core/ui/components/atoms/container";
import { Input } from "@core/ui/components/atoms/input";
import { Label } from "@core/ui/components/atoms/label";
import { Separator } from "@core/ui/components/atoms/separator";
import { Textarea } from "@core/ui/components/atoms/textarea";
import { match } from "ts-pattern";
import { jsx, jsxs } from "react/jsx-runtime";
function ContactFormField({ field }) {
  return /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-1.5", children: [
    /* @__PURE__ */ jsx(Label, { htmlFor: field.id, children: field.label }),
    match(field.type).with("text", "email", "tel", (type) => /* @__PURE__ */ jsx(
      Input,
      {
        id: field.id,
        name: field.id,
        type,
        placeholder: field.placeholder,
        required: field.required
      }
    )).with("textarea", () => /* @__PURE__ */ jsx(
      Textarea,
      {
        id: field.id,
        name: field.id,
        placeholder: field.placeholder,
        required: field.required,
        rows: 4
      }
    )).with("select", () => /* @__PURE__ */ jsx(
      Input,
      {
        id: field.id,
        name: field.id,
        type: "text",
        placeholder: field.placeholder,
        required: field.required
      }
    )).exhaustive()
  ] });
}
__name(ContactFormField, "ContactFormField");
function formatAddress(address) {
  const parts = [
    address.line1,
    ...address.line2 != null ? [address.line2] : [],
    [address.city, address.region, address.postalCode].filter(Boolean).join(", "),
    address.country
  ];
  return parts;
}
__name(formatAddress, "formatAddress");
function ContactSplit({ content, themeId }) {
  if (content == null) {
    return null;
  }
  const { heading, description, email, phone, address, formConfig } = content;
  return /* @__PURE__ */ jsx("section", { className: "bg-background px-6 py-16 m\
d:py-24", "data-theme": themeId, children: /* @__PURE__ */ jsx(Container, { size: "\
lg", children: /* @__PURE__ */ jsxs("div", { className: "grid gap-12 lg:grid-col\
s-2", children: [
    /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx("h2", { className: "text-3xl font-bold tracking-tight",
      children: heading }),
      description != null && /* @__PURE__ */ jsx("p", { className: "mt-4 text-lg\
 text-muted-foreground", children: description }),
      /* @__PURE__ */ jsx(Separator, { className: "my-8" }),
      /* @__PURE__ */ jsxs("div", { className: "flex flex-col gap-6", children: [
        email != null && /* @__PURE__ */ jsxs("div", { className: "flex items-ce\
nter gap-3", children: [
          /* @__PURE__ */ jsx(Icon, { icon: "Mail", className: "size-5 text-prim\
ary" }),
          /* @__PURE__ */ jsx(
            "a",
            {
              href: `mailto:${email}`,
              className: "text-muted-foreground hover:text-foreground",
              children: email
            }
          )
        ] }),
        phone != null && /* @__PURE__ */ jsxs("div", { className: "flex items-ce\
nter gap-3", children: [
          /* @__PURE__ */ jsx(Icon, { icon: "Phone", className: "size-5 text-pri\
mary" }),
          /* @__PURE__ */ jsx("a", { href: `tel:${phone}`, className: "text-mute\
d-foreground hover:text-foreground", children: phone })
        ] }),
        address != null && /* @__PURE__ */ jsxs("div", { className: "flex items-\
start gap-3", children: [
          /* @__PURE__ */ jsx(Icon, { icon: "MapPin", className: "mt-0.5 size-5 \
text-primary" }),
          /* @__PURE__ */ jsx("div", { className: "flex flex-col text-muted-fore\
ground", children: formatAddress(address).map((line) => /* @__PURE__ */ jsx("spa\
n", { children: line }, line)) })
        ] })
      ] })
    ] }),
    formConfig != null && /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsxs(
      "form",
      {
        action: formConfig.formAction,
        method: "POST",
        className: "flex flex-col gap-4",
        "data-success-message": formConfig.successMessage,
        children: [
          formConfig.fields.map((field) => /* @__PURE__ */ jsx(ContactFormField,
          { field }, field.id)),
          /* @__PURE__ */ jsx(Button, { type: "submit", className: "mt-2 w-full",
          children: formConfig.submitText ?? "Send Message" })
        ]
      }
    ) })
  ] }) }) });
}
__name(ContactSplit, "ContactSplit");
export {
  ContactSplit
};
